// Shared reactive state for the currently active training session, so the
// dashboard header (user + ongoing pass) and the Pass tab stay in sync and the
// elapsed timer survives tab switches.
import { reactive } from 'vue';
import api from './gymTrackerApi.js';
import { gymAuthState, refreshIfNeeded } from './gymTrackerAuth.js';

export const sessionStore = reactive({
  active: null,      // full active GymSession object, or null
  profile: null,     // { username, displayName, bodyWeightKg }
  loading: false,
});

async function withToken(fn) {
  await refreshIfNeeded();
  return fn(gymAuthState.token);
}

export async function loadActiveSession() {
  if (!gymAuthState.loggedIn) { sessionStore.active = null; return null; }
  sessionStore.loading = true;
  try {
    const d = await withToken(t => api.getActiveSession(t));
    sessionStore.active = d.activeGymSession || null;
  } catch (e) {
    console.error('[gymSessionStore] loadActiveSession failed:', e);
    sessionStore.active = null;
  } finally {
    sessionStore.loading = false;
  }
  return sessionStore.active;
}

export async function loadProfile() {
  if (!gymAuthState.loggedIn) { sessionStore.profile = null; return null; }
  try {
    const d = await withToken(t => api.getProfile(t));
    sessionStore.profile = d.myProfile || null;
  } catch (e) {
    console.error('[gymSessionStore] loadProfile failed:', e);
  }
  return sessionStore.profile;
}

export function setActiveSession(s) { sessionStore.active = s; }
export function clearActiveSession() { sessionStore.active = null; }
export function setProfile(p) { sessionStore.profile = p; }
